const QUESTIONS = {
  RUN_PAYROLL: {
    order: 1,
    text: 'Have you run payroll yet this calendar year?',
    answers: {
      yes: 'Yes',
      no: 'No',
    },
    header: 'Tell us a little about your business.',
    prev: null,
    next: {
      default: 'PREV_PAYROLL_PROVIDER',
    },
  },
  PREV_PAYROLL_PROVIDER: {
    order: 2,
    text: 'How do you currently run payroll?',
    answers: {
      new: 'We’re new to running payroll',
      Other: 'We use another online payroll software',
      'We do it ourselves manually': 'We do it ourselves manually',
    },
    header: 'Just a few more questions.',
    prev: 'RUN_PAYROLL',
    next: {
      default: 'WORKERS_TYPE',
    },
  },
  WORKERS_TYPE: {
    order: 3,
    text: 'What type of workers do you need to pay?',
    tooltip:
      'Full or part-time employees get W-2s. Independent contractors get 1099-MISC forms. Which type of worker do you need to pay?',
    answers: {
      'Yes, we have': 'Employees (W-2s)',
      contractor_only: 'Contractors (1099s)',
      'Both W-2 employees and 1099 contractors': 'Both (W-2s & 1099s)',
    },
    other_answer: {
      key: 'I don’t know',
      text: 'I’m not sure yet',
    },
    header: 'Just a few more questions.',
    prev: 'PREV_PAYROLL_PROVIDER',
    next: {
      contractor_only: null,
      default: 'HEALTH_BENEFITS',
    },
  },
  HEALTH_BENEFITS: {
    order: 4,
    text: 'Interested in offering health benefits to your team?',
    answers: {
      yes: 'Yes',
      no: 'No',
    },
    header: 'One last question.',
    prev: 'WORKERS_TYPE',
    next: {
      default: null,
    },
  },
};

export default QUESTIONS;
